<template>
  <div>
    <!-- 上传流水 -->
    <el-dialog :title="$t('message.uploadStream')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="680px" center v-loading="loading">
      <div class="content">
        <div class="row">
          <!-- 选择文件 -->
          <div class="label">{{ $t('message.selectFile') }}：</div>
          <div class="val">
            <el-upload class="upload-demo" drag :action="baseURL + '/bill.bank.uploadBill'" multiple
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :limit="1" :headers="{
                AdminToken: 'Bearer ' + token
              }" :auto-upload="false" ref="upload">
              <i class="el-icon-upload"></i>
              <div class="el-upload__tip" slot="tip">只能上传CSV，XLS，XLSX文件</div>
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      dialogVisible: false,
      loading: false,
      token: localStorage.getItem('japan_access_token'),
    };
  },
  methods: {
    // 保存
    save() {
      this.$refs.upload.submit();

    },
    //上传前
    beforeAvatarUpload(file) {
      console.log(file);
      this.loading = true;
      const xlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const xls = file.type === "application/vnd.ms-excel";
      const csv = file.type === "text/csv";
      if (!xlsx && !xls && !csv) {
        this.loading = false;
        this.$message.error("只能上传.xls或者.xlsx或者csv");
      }
      return xlsx || xls || csv;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      this.loading = false;
      this.dialogVisible = false
      this.$parent.bankList()
      this.$forceUpdate();
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
      flex: 1;
    }

    .val {
      flex: 3;
    }
  }



}
</style>